import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {USER_TYPE_NAME_MODEL} from '../../../../enums/userTypeEnum';
import { GuardSizes } from '../../../../models/GuardSizes';
import { GuardLists } from '../../../../models/GuardLists';
import cryptoJs from 'crypto-js';
import securekey from '../../../../config';
import SockJS from 'sockjs-client';
import { guardURL } from '../../../../Apis/Constants';
import { WebSocketGuard } from '../../../../reduxToolkit/Commons/CommonsApi';
import Stomp from 'stompjs';
import { userDataTransformVisitor } from '../../../../Apis/functions';

const GuardApp = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const isGuard = user?.data?.userType?.name === USER_TYPE_NAME_MODEL.GUARD;

    const [guardSizes, setGuardSizes] = useState(GuardSizes);
    const [sizeChanged, setSizeChanged] = useState(false);

    const [guardLists, setGuardLists] = useState(GuardLists);

    const [firstLoad, setFirstLoad] = useState(true);
    let isConnected;

    var clientRef = null;
    let socket;
    let stompClient;
    const token = sessionStorage.getItem('bearerToken');
    const bytes = cryptoJs.AES.decrypt(token, securekey);
    const tokenDecrpt = bytes.toString(cryptoJs.enc.Utf8);

    function handleWebSocketMessage(response) {
        const valuesNotNull = Object.values(response).every((valor) => valor !== null);
        if (valuesNotNull) {
            setGuardLists((prevData) => ({
                ...prevData,
                ...response,
            }));

            setFirstLoad(false);
        } else {
            if (response.userAccessLogs != null) {
                if (sessionStorage.getItem('guardAccessSize')) {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        userAccessLogs: [
                            response.userAccessLogs[0],
                            ...prevData.userAccessLogs.slice(0, sessionStorage.getItem('guardAccessSize') - 1),
                        ],
                    }));
                } else {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        userAccessLogs: [
                            response.userAccessLogs[0],
                            ...prevData.userAccessLogs.slice(0, guardSizes.userAccessLogSize - 1),
                        ],
                    }));
                }
            }

            if (response.userInvitations != null) {
                if (sessionStorage.getItem('guardInvitationsSize')) {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        userInvitations: [
                            response.userInvitations[0],
                            ...prevData.userInvitations.slice(0, sessionStorage.getItem('guardInvitationsSize') - 1),
                        ],
                    }));
                } else {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        userInvitations: [
                            response.userInvitations[0],
                            ...prevData.userInvitations.slice(0, guardSizes.userInvitationSize - 1),
                        ],
                    }));
                }
            }

            if (response.events != null) {
                if (sessionStorage.getItem('guardEventsSize')) {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        events: [
                            response.events[0],
                            ...prevData.events.slice(0, sessionStorage.getItem('guardEventsSize') - 1),
                        ],
                    }));
                } else {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        events: [response.events[0], ...prevData.events.slice(0, guardSizes.eventSize - 1)],
                    }));
                }
            }
            if (response.vehicleAccessLogs != null) {
                setGuardLists((prevData) => ({
                    ...prevData,
                    vehicleAccessLogs: [
                        response.vehicleAccessLogs[0],
                        ...prevData.vehicleAccessLogs.slice(0, guardSizes.vehicleAccessLogSize - 1),
                    ],
                }));
            }
            if (response.vehicleInvitations != null) {
                setGuardLists((prevData) => ({
                    ...prevData,
                    vehicleInvitations: [
                        response.vehicleInvitations[0],
                        ...prevData.vehicleInvitations.slice(0, guardSizes.vehicleInvitationSize - 1),
                    ],
                }));
            }
            if (response.orders != null) {
                if (sessionStorage.getItem('guardOrdersSize')) {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        orders: [
                            response.orders[0],
                            ...prevData.orders.slice(0, sessionStorage.getItem('guardOrdersSize') - 1),
                        ],
                    }));
                } else {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        orders: [response.orders[0], ...prevData.orders.slice(0, guardSizes.orderSize - 1)],
                    }));
                }
            }
            if (response.contracts != null) {
                if (sessionStorage.getItem('guardContractsSize')) {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        contracts: [
                            response.contracts[0],
                            ...prevData.contracts.slice(0, sessionStorage.getItem('guardContractsSize') - 1),
                        ],
                    }));
                } else {
                    setGuardLists((prevData) => ({
                        ...prevData,
                        contracts: [response.contracts[0], ...prevData.contracts.slice(0, guardSizes.orderSize - 1)],
                    }));
                }
            }
        }
    }

    // handel the logic for object transformation for all user


    const userDataTransformHost = (tras) => {
        const newData = tras?.map((item) => {
            return {
                label: `${item?.hostName || ''} ${item?.hostLastName || ''} ${item?.hostSecondLastName || ''}`.trim(),
            };
        });
        return newData;
    };

    const userDataTransformValidatedBy = (tras) => {
        const newData = tras?.map((item) => {
            return {
                label: `${item?.validatedByName || ''} ${item?.validatedByLastName || ''} ${item?.validatedBySecondLastName || ''
                    }`.trim(),
            };
        });
        return newData;
    };

    const userDataTransformSupplierEmployee = (tras) => {
        const newData = tras?.map((item) => {
            return {
                label: `${item?.supplierEmployeeName || ''} ${item?.supplierEmployeeLastName || ''} ${item?.supplierEmployeeSecondLastName || ''
                    }`.trim(),
            };
        });
        return newData;
    };

    const userDataTransformSupplierVehicle = (tras) => {
        const newData = tras?.map((item) => {
            return {
                label: `${item?.supplierVehicleBrand || ''} ${item?.supplierVehicleSubBrand || ''} ${item?.supplierVehicleModel === 0 || item?.supplierVehicleModel === null
                        ? ''
                        : item?.supplierVehicleModel
                    } | ${item?.supplierVehiclePlate || ''}`.trim(),
            };
        });
        return newData;
    };
    const userDataTransformContractor = (tras) => {
        const newData = tras?.map((item) => {
            return {
                label: `${item?.contractorName || ''} ${item?.contractorLastName || ''} ${item?.contractorSecondLastName || ''
                    }`.trim(),
            };
        });
        return newData;
    };

    useEffect(() => {
        socket = new SockJS(guardURL);
        stompClient = Stomp.over(socket);

        stompClient.connect(
            {
                headers: {
                    Authorization: `Bearer ${tokenDecrpt}`,
                },
            },
            function (frame) {
                stompClient.subscribe('/topic/guard', function (response) {
                    handleWebSocketMessage(JSON.parse(response.body));
                });
            },
        );

        (async () => {
            isConnected = false;

            while (!isConnected) {
                isConnected = stompClient.connected;
                if (isConnected) {
                    dispatch(WebSocketGuard(guardSizes));
                }
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }
        })();
        return () => {
            sessionStorage.removeItem('guardAccessSize');
            sessionStorage.removeItem('guardInvitationsSize');
            sessionStorage.removeItem('guardEventsSize');
            sessionStorage.removeItem('guardContractsSize');
            sessionStorage.removeItem('guardOrdersSize');
        };
    }, []);
    useEffect(() => {
        if (sizeChanged) {
            dispatch(WebSocketGuard(guardSizes));
            setSizeChanged(false);
        }
    }, [sizeChanged]);

    return {
        guardSizes,
        setSizeChanged,
        setFirstLoad,
        setGuardSizes,
        guardLists,
        userDataTransformVisitor,
        userDataTransformHost,
        userDataTransformValidatedBy,
        userDataTransformContractor,
        userDataTransformSupplierEmployee,
        userDataTransformSupplierVehicle,
        isGuard,
        DEV,
        navigate
    }

}



export default GuardApp;
